(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 1025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(5506);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/modules/hooks/useTranslation.ts + 44 modules
var useTranslation = __webpack_require__(1306);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
// EXTERNAL MODULE: ./src/modules/api/index.ts + 1 modules
var api = __webpack_require__(5491);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
;// CONCATENATED MODULE: ./src/modules/api/faq.ts





var getFAQList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                axios/* default.get */.Z.get("".concat( false ? 0 : "https://api.voli.ai/api/v1", "/faq"))
            ];
        });
    });
    return function getFAQList() {
        return _ref.apply(this, arguments);
    };
}();
var incrementView = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api/* default.patch */.Z.patch("/faq/".concat(id, "/view"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function incrementView(id) {
        return _ref.apply(this, arguments);
    };
}();
var incrementViewAPI = function() {
    return (0,es.useMutation)(function(id) {
        return incrementView(id);
    });
};

// EXTERNAL MODULE: ./src/styles/FAQ.module.scss
var FAQ_module = __webpack_require__(9849);
var FAQ_module_default = /*#__PURE__*/__webpack_require__.n(FAQ_module);
;// CONCATENATED MODULE: ./pages/faq/index.tsx







var FAQ = function(param) {
    var data = param.data;
    var ref = (0,useTranslation/* default */.Z)("faq"), t = ref.t, locale = ref.locale;
    var ref1 = (0,react.useState)(data.categoryList[locale][0]), category = ref1[0], setCategory = ref1[1];
    var ref2 = (0,react.useState)([]), openIdList = ref2[0], setOpenIdList = ref2[1];
    var ref3 = incrementViewAPI(), incrementView = ref3.mutateAsync;
    var onOpenClick = function(id) {
        if (!openIdList.includes(id)) setOpenIdList((0,_to_consumable_array/* default */.Z)(openIdList).concat([
            id
        ]));
        else {
            var tmp = openIdList.filter(function(item) {
                return item !== id;
            });
            setOpenIdList(tmp);
        }
        incrementView(id);
    };
    (0,react.useEffect)(function() {
        setCategory(data.categoryList[locale][0]);
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        setOpenIdList([]);
    }, [
        category
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("title")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "container",
                className: (FAQ_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (FAQ_module_default()).title,
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (FAQ_module_default()).category_list,
                        children: data === null || data === void 0 ? void 0 : data.categoryList[locale].map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat((FAQ_module_default()).category_item, " ").concat(item === category ? (FAQ_module_default()).active : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return setCategory(item);
                                    },
                                    children: item
                                })
                            }, "category-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (FAQ_module_default()).qna_list,
                        children: data === null || data === void 0 ? void 0 : data.data.filter(function(item) {
                            return item.category === category;
                        }).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (FAQ_module_default()).qna_item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return onOpenClick(item.id);
                                        },
                                        className: (FAQ_module_default()).question,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.question
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "".concat((FAQ_module_default()).answer, " ").concat(openIdList.includes(item.id) ? (FAQ_module_default()).open : ""),
                                        children: item.answer
                                    })
                                ]
                            }, item.id);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var faq = (FAQ);


/***/ }),

/***/ 9849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pc":"FAQ_pc__uoMda","mobile":"FAQ_mobile__Ho88e","hide":"FAQ_hide__ae9mX","container":"FAQ_container__7DSu8","title":"FAQ_title__zoe9s","category_list":"FAQ_category_list__vpkdA","category_item":"FAQ_category_item__eX7ar","active":"FAQ_active__IQ17u","qna_list":"FAQ_qna_list__ggEB8","qna_item":"FAQ_qna_item__62xp3","question":"FAQ_question__bK6dv","answer":"FAQ_answer__HjAzb","open":"FAQ_open__g_Jvr"};

/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1025); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);